import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriberMelody} from "../../model/subscriber-melody";
import {ServiceType} from "../../model/service-type";
import {Subscription} from "rxjs";
import {SubscriptionStatus} from "../../model/subscription-status";
import {ContentStatus} from "../../model/content-status";

@Component({
  selector: 'app-subscriber-melody-settings-modal',
  templateUrl: './subscriber-melody-settings-modal.component.html',
  styleUrls: ['./subscriber-melody-settings-modal.component.css']
})
export class SubscriberMelodySettingsModalComponent implements OnInit, OnDestroy {
  @Input() melody: SubscriberMelody;

  promo: boolean;
  subscription: Subscription;
  privetPlusSubscriptionStatus: SubscriptionStatus;
  privetSubscriptionStatus: SubscriptionStatus;
  showInfoModal: boolean;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {
    this.privetPlusSubscriptionStatus = SubscriptionStatus.NO_PROFILE;
    this.subscription = new Subscription();
    this.showInfoModal = false;
  }

  ngOnInit(): void {
    this.subscriberService.loadSubscriptions();

    this.subscription.add(
      this.subscriberService.subscriber.subscribe(subscriber => {
        if (subscriber == null) {
          this.privetPlusSubscriptionStatus = SubscriptionStatus.NO_PROFILE;
        } else {
          this.privetPlusSubscriptionStatus = subscriber.privetPlusStatus;
          this.privetSubscriptionStatus = subscriber.privetStatus;
        }
      })
    );

    this.subscription.add(
      this.subscriberService.subscriberMelodies.subscribe((melodies: ReadonlyArray<SubscriberMelody>) => {
        this.checkSubscriberMelodies(melodies as SubscriberMelody[]);
      })
    );
  }

  close(): void {
    this.modalsService.hideModal();
  }

  switchPlayingForAll(): void {
    if (this.promo && (this.privetPlusSubscriptionStatus === SubscriptionStatus.ACTIVE ||
      this.privetSubscriptionStatus === SubscriptionStatus.ACTIVE)) {
      this.melody.playingForAll = false
      this.showInfoModal = true

      return;
    }

    if (this.melody.playingForAll) {
      this.subscriberService.addToAutomate(this.melody);
    } else {
      this.subscriberService.deleteFromAutomate(this.melody);
    }
  }

  removeMelody(): void {
    this.modalsService.showSubscriberMelodyDelete(this.melody);
  }

  protected readonly ServiceType = ServiceType;

  private checkSubscriberMelodies(melodies: ReadonlyArray<SubscriberMelody>): void {
    const activeMelody = melodies?.find(m => m.contentStatus === ContentStatus.ACTIVE) ?? melodies?.[0];
    this.promo = activeMelody?.tariffType === 'PROMO';
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
